<template>
    <v-card-title>
        <v-icon class="mr-8"> mdi-account </v-icon>
        <span class="font-size-14 font-weight-regular">
            {{ text }}
        </span>
    </v-card-title>
</template>

<script>
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState("lecture/chat", ["count"]),
        text() {
            return `${(this.count || 0).format()} 명 `;
        },
    },
};
</script>

<style>
</style>